import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["hidden", "form"]

  change(event) {
    const value = event.target.value

    
    if (this.hasHiddenTarget) {
      this.hiddenTarget.value = value
    }

    if (this.hasFormTarget) {
      this.formTarget.requestSubmit() // Turbo対応
    }
  }
}
